import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { color, radius, space, device, Text, fontWeight, H4, fontSize } from '@ticketswap/solar'
import SecureSwapMark from '~/components/SecureSwapMark'

const Container = styled.div`
  background-color: ${color.nova};
  border-radius: ${radius.lg};
  padding: ${space[16]};
  border: 1px solid ${color.spaceLightest};
  display: grid;
  grid-template-columns: 1fr 0.3fr;
  grid-gap: ${space[16]};
  align-items: center;

  @media ${device.tablet} {
    padding: ${space[32]};
  }
`

const StyledText = styled(Text)`
  color: ${color.spaceMedium};
  font-size: ${fontSize[16]};

  @media ${device.tablet} {
    font-size: ${fontSize[16]};
  }
`

const SecureSwapLogo = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${color.titanLightestAlpha};
`

const StyledTitle = styled(H4)`
  font-weight: ${fontWeight.semiBold};
`

const StyledSecureSwapMark = styled(SecureSwapMark)`
  width: 36px;
  height: 38.3px;
  min-width: 36px;
  min-height: 38.3px;
  /* Vertical align */
  margin-top: 2px;
`

const ListingSecureSwap = ({ t, listing }) => {
  if (!listing.isSecureSwapAvailable) {
    return null
  }

  return (
    <Container>
      <div>
        <StyledTitle>{t('listing:purchaser.secureSwapTitle')}</StyledTitle>
        <StyledText as="p">{t('listing:purchaser.secureSwap')}</StyledText>
      </div>

      <SecureSwapLogo>
        <StyledSecureSwapMark />
      </SecureSwapLogo>
    </Container>
  )
}

ListingSecureSwap.propTypes = {
  t: PropTypes.func.isRequired,
  listing: PropTypes.shape({
    id: PropTypes.string,
    seller: PropTypes.object,
    isSecureSwapAvailable: PropTypes.bool,
  }),
}

export default ListingSecureSwap
